import { render, staticRenderFns } from "./wtIconWithText.component.vue?vue&type=template&id=59a282b5&"
import script from "./wtIconWithText.component.vue?vue&type=script&lang=js&"
export * from "./wtIconWithText.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports